import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import React from "react";
import "react-tabs/style/react-tabs.css";

export default function HomeTab({ data }) {
  return (
    <section className="home-tab space">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8">
            <div className="home-tab-text  heading-center">
              <span className="subtitle">INNOVATIVE SOLUTIONS</span>
              <h2 className="heading"> Built for Purpose, Designed to Flow</h2>
              <p>  Engineered with precision and flexibility, our platform adapts seamlessly to your business needs, delivering efficiency, scalability, and continuous performance improvement.  </p>
            </div>
          </div>
        </div>

        <div className="tabber-area">
          <Tabs>
            <TabList>  {data.map((item, index) => (<Tab key={index}>{item.title}</Tab>))} </TabList>
            {data.map((item, index) => (
              <TabPanel key={index}>
                <div className="recent-tab">
                  <div className="tab-col">
                    <div className="row align-items-center">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="recent-inner">
                          <div className="content">
                            <h3 className="heading">{item.heading}</h3>
                            <p>{item.description}</p>
                            <div className="recent-item">
                              <div className="tab-btn"> <Link className="theme-btn" to={item.link}>  <span>Learn more</span> </Link>   </div>
                              {item.testimonial && (
                                <div className="tabber-bio">
                                  <span className="border-left-bg"></span>
                                  <div className="bio-description">
                                    <p>{item.testimonial.text}</p>
                                    <div className="name-wrapper">
                                      <span className="name">    {item.testimonial.name},{" "}  </span>
                                      <span className="designation">   {item.testimonial.designation}   </span>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="recent-inner">
                          <div className="image">
                            <div className="img-animation">
                              <img src={item.image} className="img-responsive" alt={item.heading} loading="lazy" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
            ))}
          </Tabs>
        </div>
      </div>
    </section>
  );
}
